var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlexibleConsumption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,52.75H58v-1.5H56.75V16a.7502.7502,0,0,0-.75-.75H48a.7502.7502,0,0,0-.75.75V51.25h-2.5V26a.7502.7502,0,0,0-.75-.75H36a.7502.7502,0,0,0-.75.75V51.25h-2.5V36a.7502.7502,0,0,0-.75-.75H24a.7502.7502,0,0,0-.75.75V51.25H22v1.5H32Zm16.75-36h6.5v34.5h-6.5Zm-12,10h6.5v24.5h-6.5Zm-12,10h6.5v14.5h-6.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25,11.81049V18h1.5V10A.7502.7502,0,0,0,34,9.25H26v1.5h6.18945L12.53809,30.3999A10.74985,10.74985,0,0,0,20.13965,48.751v-1.5a9.25,9.25,0,0,1-6.541-15.79053Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.79,37.88623A10.58214,10.58214,0,0,0,59.85938,31.25v1.5a9.25026,9.25026,0,0,1,6.54,15.791L46.75,68.19092V62h-1.5v8a.7502.7502,0,0,0,.75.75h8v-1.5H47.812L67.46,49.60156A10.5825,10.5825,0,0,0,69.79,37.88623Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlexibleConsumption);
export default __webpack_public_path__ + "static/media/icon_flexible_consumption.8b7d7490e173e2f9724387abcf7f54b2.svg";
export { ForwardRef as ReactComponent };